import GoalCard from "./goal-card"
import AddGoalCard from "./add-goal-card"
import { Target } from "lucide-react"

export interface Goal {
  id: string
  title: string
  description: string
  progress: number
  dueDate: string
  icon: "Gamepad2" | "Calculator" | "BookOpen" | "Beaker" | "Music" | "Rocket"
  iconBgColor: string
  iconColor: string
  isCompleted: boolean
  completedDate?: string
}

interface ActiveGoalsProps {
  goals: Goal[]
  onDeleteGoal: (id: string) => void
  onEditGoal: (id: string, updatedGoal: Partial<Goal>) => void
}

export default function ActiveGoals({ goals, onDeleteGoal, onEditGoal }: ActiveGoalsProps) {
  if (goals.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-center">
        <div className="w-16 h-16 rounded-2xl bg-slate-100 border border-slate-200 flex items-center justify-center mb-4">
          <Target className="w-8 h-8 text-slate-400" />
        </div>
        <h3 className="text-lg font-bold text-slate-900 mb-1">No goals yet</h3>
        <p className="text-sm text-slate-500 mb-6 max-w-xs">Set your first goal to start tracking your progress and stay on track.</p>
        <AddGoalCard />
      </div>
    )
  }

  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
      {goals.map((goal) => (
        <GoalCard key={goal.id} goal={goal} onDelete={onDeleteGoal} onEdit={onEditGoal} />
      ))}
      <AddGoalCard />
    </div>
  )
}
